import MenuIcon from '@material-ui/icons/Menu';

import logoWhite from '../../../logo_white.png';
import { MenuButton, MenuButtonContainer, StyledAppBar, StyledToolbar } from './styled';

/*
 * This component renders the top app bar, containing the name of the app
 * and the button to open the drawer on small screens.
 */

interface Props {
    showSidebar: boolean;
    openDrawer: () => void;
}

const AppBar = (props: Props) => {
    const { showSidebar, openDrawer } = props;

    return (
        <StyledAppBar position='fixed'>
            <StyledToolbar>
                <MenuButtonContainer show={showSidebar}>
                    <MenuButton color='inherit' edge='start' onClick={openDrawer} >
                        <MenuIcon />
                    </MenuButton>
                </MenuButtonContainer>

                <img alt='Logo' src={logoWhite} style={{ maxWidth: 'calc(100% - 48px)', maxHeight: '120px', margin: '0 auto 0' }} />
            </StyledToolbar>
        </StyledAppBar>
    );
};

export default AppBar;
